import React from 'react'

import { useTranslation } from 'react-i18next'
import FA from 'react-fontawesome'
import ContextLoading from '../Loading'

import { Background, Container } from './styles'
import { getCurrentLng } from '../../config/i18n'

interface Props {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}
export default function ({ isOpen, setIsOpen }: Props) {
  const { t, ready } = useTranslation(['components/contact'])
  const form = {
    'pt-BR': 'https://share.hsforms.com/1c5h7sZjiQ0SvEeqqLdnzng59hag',
    'en-US': 'https://share.hsforms.com/1QcMO0Po9SNOstHygZOYb2A59hag',
  }

  return (
    <ContextLoading isLoading={!ready}>
      <Background isOpen={isOpen}>
        <Container isOpen={isOpen}>
          <button
            className="close"
            onClick={() => setIsOpen(!isOpen)}
            type="button"
          >
            <FA size="2x" name="times" />
          </button>
          <h3>{t('title')}</h3>
          <iframe
            frameBorder="0"
            title={t('title')}
            src={form[getCurrentLng()]}
          />
        </Container>
      </Background>
    </ContextLoading>
  )
}
